<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import BlocksWrapper from '@/components/shared/blocks/BlocksWrapper.vue';
import { IDocument } from '@/interfaces';
import BaseOverlay from '@/overlays/BaseOverlay.vue';
import MediaPreview from '@/overlays/MediaPreviewOverlay.vue';
import { ref } from 'vue';

const emit = defineEmits(['close']);

interface Props {
  documents: IDocument[];
  isPersonalMedia?: boolean;
}

withDefaults(defineProps<Props>(), {});

const showMediaPreview = ref<boolean>(false);
const selectedMediaIndex = ref<number>(0);

const documentSelected = (index: number) => {
  showMediaPreview.value = true;
  selectedMediaIndex.value = index;
};
</script>

<template>
  <BaseOverlay
    @close="emit('close')"
    :title="isPersonalMedia ? $t('media.myDocuments') : $t('global.documents')"
  >
    <template #content>
      <BlocksWrapper>
        <BasicBlock
          v-for="(document, index) in documents"
          :key="index"
          :text="document.title"
          :icon="['fal', 'fa-file-alt']"
          :can-trigger-overlay="true"
          @click="documentSelected(index)"
        />
      </BlocksWrapper>
    </template>
  </BaseOverlay>

  <MediaPreview
    v-if="showMediaPreview"
    media-type="documents"
    :selected-item-index="selectedMediaIndex"
    :items="documents"
    :allow-archive-remove="isPersonalMedia"
    @close-preview="showMediaPreview = false"
  />
</template>
